import { has, isBoolean } from 'lodash'

export interface LinkDtoOutput {
  Url: string
  Order: number
  Code: string
}

export interface GetInitialConfigurationOutput {
  UseRecaptcha: boolean
  AuthenticationMethods: {
    InternalLogins: GetInitialConfigurationLoginDetail[]
    ExternalLogins: GetInitialConfigurationLoginDetail[]
  }
  AuthorizeClientInformation?: {
    AuthorizeClientName: string
    Links: LinkDtoOutput[]
  }
}

export interface GetInitialConfigurationLoginDetail {
  Provider: string
  Order: number
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isGetInitialConfigurationOutput = (output: any): output is GetInitialConfigurationOutput => {
  const UseRecaptcha = 'UseRecaptcha'
  return has(output, UseRecaptcha) && isBoolean(output[UseRecaptcha])
}
